const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

/**
 * Format an incoming number into a currency value
 */
export function formatCurrency(number: number) {
  return formatter.format(number);
}
